import { Base, Event, IBaseProps, IBaseState, IResource } from "./Base";
import * as React from "react";
import { toast } from "react-semantic-toasts";
import { Confirm, Icon, Popup } from "semantic-ui-react";

export interface IDeleteResourceProps extends IBaseProps {
  resource: IResource;
  deleted: () => void;
}

export interface IDeleteResourceState extends IBaseState {
  deleteConfirmOpen: boolean;
}

class DeleteResource extends Base<IDeleteResourceProps, IDeleteResourceState> {
  constructor(props: IDeleteResourceProps) {
    super(props);
    this.state = { ...Base.BASE_INITAL_STATE, deleteConfirmOpen: false };
  }
  render() {
    const { resource } = this.props;
    const { deleteConfirmOpen } = this.state;
    return (
      <React.Fragment>
        <Popup
          content={`Delete ${resource.type.singular}`}
          position="bottom left"
          trigger={
            <Icon
              link={true}
              name="trash"
              onClick={() => this.handleDeleteResource()}
            />
          }
        />
        {deleteConfirmOpen && (
          <Confirm
            size="mini"
            header={`Confirm delete ${resource.type.singular}`}
            content={`Are you sure you want to delete "${resource.name}"?`}
            cancelButton="No"
            confirmButton="Yes"
            open={deleteConfirmOpen}
            onCancel={this.handleCloseConfirm}
            onConfirm={this.handleConfirmDeleteResource}
          />
        )}
      </React.Fragment>
    );
  }

  private handleCloseConfirm = () => {
    this.setState({ deleteConfirmOpen: false });
  };

  private handleDeleteResource = () => {
    this.setState({ deleteConfirmOpen: true });
  };

  private handleConfirmDeleteResource = () => {
    const { orgId, authUser, resource, deleted } = this.props;
    resource.api
      .deleteResource(authUser.uid, resource.id)
      .then((requestRef: firebase.database.Reference) => {
        this.getListner(
          resource.api.getApiResponse(orgId, authUser.uid, requestRef.key),
          Event.Value,
          (snapshot: firebase.database.DataSnapshot) => {
            const resp = snapshot.val();
            if (resp && resp.headers) {
              if (resp.headers.statusCode === 200) {
                this.setState({ deleteConfirmOpen: false }, () => {
                  deleted();
                });
              } else {
                toast({
                  type: "error",
                  icon: "info circle",
                  title: `failed to remove ${resource.type.singular}  `,
                  animation: "slide up",
                  time: 5000,
                });
              }
            }
          },
          (error: Error) => {
            console.log(error);
          }
        );
      })
      .catch((error) => {
        console.log(error);
      });
  };
}

export default DeleteResource;



// WEBPACK FOOTER //
// ./src/components/Common/DeleteResource.tsx